import { useState } from 'react'

export default function EditorialFrame({
  frame,
  onOpen,
  priority = false,
  className = '',
  showCaption = true,
}) {
  const [failed, setFailed] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const label = [frame.caption, frame.category].filter(Boolean).join('. ')

  return (
    <figure className={className}>
      <button
        type="button"
        onClick={() => onOpen?.(frame)}
        className="group block w-full text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-cinema-gold"
        aria-label={label || frame.alt || 'Open image'}
      >
        <span
          className="relative block w-full overflow-hidden bg-cinema-charcoal"
          style={{ aspectRatio: frame.ratio || '4 / 5' }}
        >
          {!failed && (
            <img
              src={frame.src}
              alt={frame.alt || ''}
              width={1600}
              height={1200}
              loading={priority ? 'eager' : 'lazy'}
              decoding="async"
              fetchPriority={priority ? 'high' : 'low'}
              onLoad={() => setLoaded(true)}
              onError={() => setFailed(true)}
              className={`absolute inset-0 h-full w-full object-cover transition duration-700 ease-out motion-safe:group-hover:scale-[1.03] ${frame.position || 'object-center'} ${loaded ? 'opacity-100' : 'opacity-0'}`}
            />
          )}
          {failed && (
            <span className="absolute inset-0 flex items-end p-4 text-[0.65rem] uppercase tracking-[0.22em] text-cinema-muted font-sans">
              SMA
            </span>
          )}
        </span>
      </button>
      {showCaption && (frame.caption || frame.category) && (
        <figcaption className="pt-3">
          {frame.category && (
            <p className="text-[0.65rem] uppercase tracking-[0.18em] text-cinema-gold font-sans">{frame.category}</p>
          )}
          {frame.caption && (
            <p className="mt-1 font-display text-lg text-white font-light">{frame.caption}</p>
          )}
        </figcaption>
      )}
    </figure>
  )
}
